import React, { Component } from 'react';
import _ from 'lodash';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import './stylesheets/InformeeTable.css';

import { MergeAttributes } from '../FlatData';

class InformeeTable extends Component {
  constructor(){
    super();

    this.showMemberCount = this.showMemberCount.bind(this);
    this.createCustomToolBar = this.createCustomToolBar.bind(this);
  }

  showMemberCount(cell, row){
    return row.member_names.length;
  }

  createCustomToolBar(props) {
    return (
      <div className='ml-auto col-6'>
        { props.components.searchPanel }
      </div>
    );
  }

  render(){
    const data = MergeAttributes(this.props.informees);

    const selectRowProp = {
        mode: 'checkbox',
        clickToSelect: true,
        onSelect: this.props.onRowSelect,
        selected: this.props.selected
    };
    const options = {
      sizePerPageList: [],
      toolBar: this.createCustomToolBar
    };

    return(
      <div className="row">
        <div className="col-12 col-md-7 rui-dpg-table">
          <BootstrapTable 
            data={data}
            search={ true }
            multiColumnSearch={ true }
            selectRow={ selectRowProp }
            options={ options }
            striped
            hover
            condensed
            pagination
            version='4'
            tableContainerClass={'table-sm'}>
              <TableHeaderColumn isKey dataField='id' hidden></TableHeaderColumn>
              <TableHeaderColumn dataField='name' dataSort={ true }>เรียน</TableHeaderColumn>
              <TableHeaderColumn dataField='user_name' dataSort={ true }>ชื่อ-สกุล</TableHeaderColumn>
          </BootstrapTable>
        </div>
        <div className="col-12 col-md-5 pl-md-0 mb-3">
          <h4>ตั้งค่าเรียนภายในกลุ่มเรียน {`(${this.props.selected.length})`}</h4>
          <div className={`${this.props.selected.length > 0 && "card"}`}>
            <ul id="selected-department-groups" className="list-group list-group-flush">
              {this.props.selected.map(informeeId => {
                let informee = _.find(this.props.informees, {id: informeeId});
                if (informee === undefined){ return }

                return(
                  <li className="list-group-item" key={informeeId}>
                    {informee.name}
                    <br />
                    <span className="text-success xs-small">{informee.user_name}</span>
                    <i className='fa fa-times close-icon text-danger' onClick={() => this.props.removeSelected(informeeId)}></i>
                  </li>
                )
              })}
            </ul>
          </div>
        </div>

        <div className="modal-footer col-12">
          <button type='button' className="btn btn-primary pointer" onClick={this.props.onSubmit}>บันทึกข้อมูล</button>
          <button type='button' className="btn btn-secondary pointer" onClick={this.props.onClose}>ยกเลิก</button>
        </div>
      </div>
    )
  }
}

export default InformeeTable;



// WEBPACK FOOTER //
// ./src/components/InformGroup/InformeeTabel.js